<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { RouterLink } from "vue-router";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/shared/ui";

/**
 * Публічна заглушка поза app-shell (signup / forgot-password): центрована
 * картка з заголовком, поясненням, лінком назад на login і контактом підтримки.
 * Widget-рівнева композиція над `Card` (не DS-примітив).
 */
defineProps<{
  title: string;
  subtitle: string;
  backLabel: string;
  testid?: string;
}>();

const { t } = useI18n();
</script>

<template>
  <main
    :data-testid="testid"
    class="grid min-h-dvh place-items-center bg-background p-6"
  >
    <Card class="w-full max-w-sm">
      <CardHeader class="text-center">
        <CardTitle>{{ title }}</CardTitle>
        <CardDescription>{{ subtitle }}</CardDescription>
      </CardHeader>
      <CardContent class="flex flex-col items-center gap-3">
        <RouterLink
          to="/login"
          class="rounded-sm text-sm font-medium text-primary underline-offset-4 outline-none hover:underline focus-visible:ring-[3px] focus-visible:ring-ring/50"
        >
          {{ backLabel }}
        </RouterLink>
        <a
          href="mailto:support@salonos.app"
          class="text-sm text-muted-foreground underline-offset-4 hover:underline"
        >
          {{ t("auth.login.supportLink") }}
        </a>
      </CardContent>
    </Card>
  </main>
</template>
